module.exports = __webpack_public_path__ + "pc/static/img/plu.2ae7a1e0.png";